import { formatPrice } from '@moda/portal-stanchions';
import React from 'react';
import { OrderItem } from '../../../hooks/useOrder';

import './OrderItemPrice.scss';

interface Props {
  item: OrderItem;
  layout: 'row' | 'column';
}

export const OrderItemPrice: React.FC<Props> = ({
  item: {
    attributes: {
      prices: { depositPrice, retailPrice, totalPrice }
    }
  },
  layout
}) => (
  <div className={layout === 'row' ? 'OrderItemPrice--row' : 'OrderItemPrice'}>
    {retailPrice.price !== totalPrice.price && (
      <div className="OrderItemPrice__original">
        {formatPrice(retailPrice.currency, retailPrice.price)}
      </div>
    )}
    <div>{formatPrice(totalPrice.currency, totalPrice.price)}</div>
    {Number(depositPrice.price) > 0 && (
      <div className="OrderItemPrice__deposit">
        ({formatPrice(depositPrice.currency, depositPrice.price)} Deposit)
      </div>
    )}
  </div>
);
